import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import { GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

import {
    TableToolbarExport,
    toolbarSlotProps,
} from "components/Table/TableToolbarExport";

import { S } from "./components.styles";

type Props = {
    fileName?: string;
    handleExport?: () => void;
};

export const Toolbar = (props: Props) => {
    const { fileName, handleExport } = props;
    const { t } = useTranslation();

    return (
        <S.ToolbarContainer>
            <GridToolbarColumnsButton slotProps={toolbarSlotProps} />

            {handleExport ? (
                <Button
                    sx={toolbarSlotProps.button.sx}
                    onClick={handleExport}
                    disableFocusRipple
                    startIcon={<Download />}
                >
                    {t("common.download", "Download")}
                </Button>
            ) : (
                <TableToolbarExport
                    csvOptions={{ fileName }}
                    hasCustomStyle={true}
                />
            )}
        </S.ToolbarContainer>
    );
};
